// extracted by mini-css-extract-plugin
export default {"root":"ShareReportModal_root__ydB62","closeWrapper":"ShareReportModal_closeWrapper__YKDIm","closeIcon":"ShareReportModal_closeIcon__1scSl"};